<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <Component
        :is="contentfulContentBlock"
        v-if="errorContent"
        :contentRows="errorContent.rows"
        :contentTitle="errorContent.title"
    />
</template>

<script setup>
import { onBeforeMount } from 'vue';

import useAnalyticsPageView from '~coreModules/analytics/js/composables/use-analytics-pageview';
import { useActions, useState } from '~coreModules/core/js/composables/vuexHelpers';

import { CONTENT_SLUGS } from '~coreModules/contentful/js/contentful-constants';
import { FETCH_ERROR_CONTENT } from '~coreModules/core/js/store';

useAnalyticsPageView();

defineProps({
    contentfulContentBlock: {
        type: [Function, Object],
        required: true,
    },
});

const { errorContent } = useState([
    'errorContent',
]);

const { fetchErrorContent } = useActions({
    fetchErrorContent: FETCH_ERROR_CONTENT,
});

onBeforeMount(async () => {
    await fetchErrorContent({ slug: CONTENT_SLUGS.NOT_FOUND_PAGE });
});

</script>
